import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

//It is called OAuth, but it is not actually OAuth

const DatasourceCarerixOAuth = (props) => {

    const Fields = [
        {Identifier:"ClientId", Translation:Translate("Client ID"), Required:true},
        {Identifier:"ClientSecret", Translation:Translate("Client secret"), Required:true, PasswordField:true},
        {Identifier:"SystemName", Translation:Translate("System name"), Required:true},
        {Identifier:"TokenEndpoint", Translation:"Token endpoint", Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)
    
}

DatasourceCarerixOAuth.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceCarerixOAuth